import { render } from "./Header.vue?vue&type=template&id=89d4d1a6"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=89d4d1a6&lang=less"
script.render = render

export default script